import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';
import Config from "../../../config/Config";
import SvGraphics from "../../../assets/SvGraphics";
import Error from "../../../components/single_components/Error";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Constants from "../../../utils/constants";
import AlertConfirm from "../../../components/modals/Confirm";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";
import Translate from "../../../utils/Translate";
import ReactFlagsSelect from "react-flags-select";
import LeumitLogo from "../../../assets/LeumitLogo.png"
import {appendIchilovQuery, hasIchilovQuery} from "../../../utils/routeUtils";
import ichilovImg from "../../../assets/Soraski.svg";

class LeumitResetPasswordComposed extends Component {
    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef()

        this.state = {
            username: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            username: Yup.string().matches(Constants.emailRegExp, t('defaults.rst_pwd.username_inv')).required(t('defaults.rst_pwd.username_req'))
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    goBack() {
        this.props.history.push(appendIchilovQuery('/login_pain'))

    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }
    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {username} = this.state
        let response = await authenticationService.resetPassword(username, reCaptchaToken);
        if (response.status < 400) {
            let confirm = await AlertConfirm({
                options: {
                    title: t('defaults.rst_pwd.pwd_rst'),
                    cancelLabel: 'none',
                    proceedLabel: t('defaults.rst_pwd.Ok')
                }
            }, `${t('defaults.rst_pwd.new_pwd_sent')}: ${username}`)
            if (confirm) {
                this.goBack()
            }
        } else {
            this.setState({
                isErr: true,
                errMessage: response.data.message,
                username: '',
                password: '',
                auth: {}
            })
        }
    }

    setUserName = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({username: e.target.value, isErr: false})
        utils.set(auth, 'username', e.target.value)
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'username')) {
            utils.set(errorsOnSave, 'username', utils.get(errors, 'username'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave
        })
    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }

    render() {
        let {t} = this.props
        return (
            <div className={"login-page-Leumit"}>
                <div className={'sade-right-changeLang'}>

                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-Pain-login-logo-container'}>
                    <SvGraphics svgname={'painClinicLogo'} className={'sade-Pain-login-logo'}/>
                    {hasIchilovQuery() ? <img src={ichilovImg} className={'sade-Pain-login-logo'} alt={""}/> :
                        <img src={LeumitLogo} className={'sade-Pain-login-logo'} alt={""}/>
                    }
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-reset-Leumit'}>{t('defaults.rst_pwd.rst_pwd')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.rst_pwd.username')}
                                           type={"text"}
                                           name={"Username"}
                                           id={"search"}
                                           onChange={e => this.setUserName(e)}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'username') ? "input-pic2" : "input-pic"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'username')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'username')}/>
                            </div>


                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit.bind(this)}>{t('defaults.rst_pwd.rst_pwd')}</button>
                            </div>
                        </div>
                    </div>
                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.rst_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                    <div className={'leumit-login-footer-container2'}
                         onClick={() => this.goBack()}>
                        <a>{t('defaults.rst_pwd.back_to_login')}</a>
                    </div>
                </div>


                <div className={'sade-Pain-bottom-container2'}>
                    <div className="need-help-label">
                        {t('defaults.Registration.need_help')}
                    </div>

                    <div className="need-help-block">

                        <div className="need-help-block-content">
                            <SvGraphics svgname={'global'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} target={"_blank"}
                                   href={'https://www.sade.group/he/pain'}>www.sade.group</a>
                            </div>

                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'email-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="mailto: pain@sade.group">pain@sade.group</a>
                            </div>

                        </div>


                        <div className="need-help-block-content">
                            <SvGraphics svgname={'phone-icon'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>
                                <a className={"login-website-label"} href="tel:073-380-7972">073-380-7972</a>
                            </div>
                        </div>
                        <div className="need-help-block-content">
                            <SvGraphics svgname={'clock'} className={"login-website-icon"}/>

                            <div className={"login-website-div"}>

                                <a className={"login-website-label"}
                                   href="">{t('patient_self_boarding.workingHours')}</a>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let PainResetPassword = compose(
    withTranslation()
)(LeumitResetPasswordComposed)

export default PainResetPassword;
